import CrfForm from "./crf_form";
import LogFormTableWrapper from "./log_form_table";

export default function Crf(props) {
  const { form_type, multi_entry_crf_id = null } = props;

  if (multi_entry_crf_id && form_type === "multi_entry") {
    return <CrfForm {...props} />;
  } else if (form_type === "multi_entry") {
    return <LogFormTableWrapper {...props} />;
  } else {
    return <CrfForm {...props} />;
  }
}
